import React from "react"
import CircularProgress from "material-ui/CircularProgress"
import ContentAdd from "material-ui/svg-icons/content/add"
import FloatingActionButton from "material-ui/FloatingActionButton"
import TableActionBar from "../../../components/layout/TableActionBar"
import AddDeviceDialog from "../../../components/device/AddDeviceDialog"
import strings from "../../../localization/strings"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import autobind from "class-autobind"
import * as permissionHelper from "../../../helpers/permissionHelper"
import * as api from "../../../api"
import { IHierarchyItem, IDeviceDocument, EAddDeviceValidationType, IDeviceReportColumns } from "../../../models"
import DeviceTable from "../../../components/device/DeviceTable"
import AppStateStore from "../../../stores/AppStateStore"
import AccountStore from "../../../stores/AccountStore"
interface IProps {
    hierarchyItem: IHierarchyItem
}
interface IState {
    hierarchyItem: IHierarchyItem
    loading: boolean
    searchText: string
    total: number
    offset: number
    limit: number
    limitOptions: number[]
    devices: IDeviceDocument[]
    selectedDevices: IDeviceDocument[]
    openAddDeviceDialog: boolean
    editDevice: IDeviceDocument
    confirmDialogTitle: string
    confirmDialogPayload: any
}

export default class HierarchyDevices extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
            hierarchyItem: props.hierarchyItem,
            loading: true,
            searchText: "",
            total: 0,
            offset: 0,
            limit: 20,
            limitOptions: [20, 50, 100],
            devices: [],
            selectedDevices: [],
            openAddDeviceDialog: false,
            editDevice: null,
            confirmDialogTitle: "",
            confirmDialogPayload: null,
        }
        autobind(this)
    }

    componentDidMount() {
        this.getDevices()
    }

    componentWillReceiveProps(nextProps) {
        nextProps.hierarchyItem.Id !== this.props.hierarchyItem.Id &&
            this.setState({ hierarchyItem: nextProps.hierarchyItem }, () =>
                this.getDevices()
            )
    }

    getDevices() {
        api.getHierarchyLevelDevices(AuthenticationStore.getCookieAccountId(), this.state.hierarchyItem.Id, this.state.offset / this.state.limit, this.state.limit, this.state.searchText).then(res =>
            this.setState({
                total: res.data.TotalDocumentCount,
                devices: res.data.Documents,
                selectedDevices: [],
                loading: false
            })
        )
    }

    handleDeleteDevices(devices: IDeviceDocument[]) {
        AppStateStore.setProgressSnackbarContent("loading")
        setTimeout(() =>
            Promise.all(
                devices.map(device =>
                    new Promise(resolve =>
                        api.deleteLocationDevice(this.props.hierarchyItem.Id, device.Id).then(() => resolve(1))
                    )
                )
            ).then(() => {
                AppStateStore.setProgressSnackbarContent(strings.Successfully_deleted)
                this.getDevices()
            })
            , 1000
        )
    }

    handleAddDevice(device) {
        return api.addHierarchyLevelDevice(AuthenticationStore.getCookieAccountId(), this.props.hierarchyItem.Id, device).then(res => {
            const result = res.data as EAddDeviceValidationType
            result === EAddDeviceValidationType.Valid &&
                this.getDevices()
            return result
        })
    }

    handleEditDevice(device) {
        return api.patchDevice(device).then(res => {
            this.getDevices()
            return res
        })
    }

    render() {
        const editPermission = permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.EditHierarchyDevices)
        return (
            <div className="HierarchyDevices" style={{ position: "relative" }}>
                {permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.AddHierarchyDevices) &&
                    <FloatingActionButton data-intercom-target={"menu-Hierarchy-Devices-Btn-Add"} className="fixed-add" style={{ top: -110, right: 20 }} secondary onTouchTap={() => this.setState({ openAddDeviceDialog: true })}>
                        <ContentAdd />
                    </FloatingActionButton>
                }
                <div>
                    <TableActionBar
                        rowSelectionCount={this.state.selectedDevices.length}
                        singleSelectedMessage={strings.Device_Selected}
                        multipleSelectedMessage={strings.x_Devices_Selected}
                        title={null}
                        onSearch={searchText => this.setState({ searchText }, () => this.getDevices())}
                        searchText={this.state.searchText}
                        onDeleteClick={() =>
                            AppStateStore.setConfirmDialogContent({
                                title: strings.Delete_Selected_Devices,
                                content: this.state.selectedDevices.length > 1 ? strings.Are_you_sure_delete_devices : strings.Are_you_sure_delete_device,
                                confirm: () => this.handleDeleteDevices(this.state.selectedDevices)
                            })
                        }
                        readonly={!permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices)}
                    />
                    {this.state.loading ?
                        <div className="spinner">
                            <CircularProgress />
                        </div> :
                        !this.state.devices.length ?
                            <div>
                                <h2 style={{ textAlign: "center", paddingTop: 25, paddingBottom: 50 }}>
                                    {`${strings.No} ${this.props.hierarchyItem.Label} ${strings.Devices}`}
                                </h2>
                            </div> :
                            <DeviceTable
                                total={this.state.total}
                                limit={this.state.limit}
                                page={this.state.offset}
                                limitOptions={this.state.limitOptions}
                                devices={this.state.devices}
                                selectedDevices={this.state.selectedDevices}
                                deviceColumns={{
                                    IncludeName: true,
                                    IncludeConnected: true,
                                    IncludeType: true,
                                    IncludeCode: true,
                                    IncludeMode: true,
                                    IncludePhoneNumber: AccountStore.getIVREnabled(),
                                    IncludeOS: true,
                                    IncludeDescription: true,
                                    IncludeAppVersion: true,
                                    IncludeActive: true,
                                    IncludeDevicePermissions: true
                                } as IDeviceReportColumns}
                                selectPermission={permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.DeleteHierarchyDevices)}
                                editPermission={editPermission}
                                onPageClick={offset => this.setState({ offset }, () => this.getDevices())}
                                onLimitChange={limit => this.setState({ limit, offset: 0 }, () => this.getDevices())}
                                onRowClick={editDevice => this.setState({ openAddDeviceDialog: true, editDevice })}
                                handleSelect={selectedDevices => this.setState({ selectedDevices })}
                            />
                    }
                </div>
                {this.state.openAddDeviceDialog &&
                    <AddDeviceDialog
                        isHierarchyDevice
                        readonly={!editPermission}
                        editableDevice={this.state.editDevice}
                        handleClose={() => this.setState({ openAddDeviceDialog: false, editDevice: null })}
                        handleAdd={this.handleAddDevice}
                        handleUpdate={this.handleEditDevice}
                    />
                }
            </div>
        )
    }
}
